import { useState } from "react";
import { Button } from "../design/button";
import { DiscoveryRequestTaskResponse } from "../models/DiscoveryRequestTaskResponse";
import { DiscoveryRequestTaskResponseService } from "../services/DiscoveryRequestTaskResponseService";
import { EyeIcon } from "@heroicons/react/20/solid";

interface Props {
  discoveryRequestTaskResponse: DiscoveryRequestTaskResponse;
}

const DownloadDiscoveryRequestTaskResponseButton: React.FC<Props> = ({
  discoveryRequestTaskResponse,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  if (!discoveryRequestTaskResponse.blobName) return null;

  const handleDownloadButtonPressed = async () => {
    setIsDownloading(true);
    try {
      const downloadUrl =
        await DiscoveryRequestTaskResponseService.getDownloadURL(
          discoveryRequestTaskResponse._id,
        );
      window.open(downloadUrl, "_blank");
    } catch (error) {
      console.error("Error downloading discoveryRequestId:", error);
    }
    setIsDownloading(false);
  };
  return (
    <Button
      plain
      disabled={isDownloading}
      onClick={handleDownloadButtonPressed}
    >
      <EyeIcon className="w-4 h-4 mr-2" />
    </Button>
  );
};

export default DownloadDiscoveryRequestTaskResponseButton;
